import { render, staticRenderFns } from "./showshare.vue?vue&type=template&id=026a7c5e&scoped=true"
import script from "./showshare.vue?vue&type=script&lang=js"
export * from "./showshare.vue?vue&type=script&lang=js"
import style0 from "./showshare.vue?vue&type=style&index=0&id=026a7c5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a7c5e",
  null
  
)

export default component.exports